import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'

import request from './common/request'
import './common/weida.scss'
import weidajs from './common/weida.js'
import {
	setToken
} from './common/auth.js'
import * as filters from './filters' // global filters

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
import crypto from 'crypto-js'
Vue.config.productionTip = false

Vue.prototype.$weidajs = weidajs
Vue.prototype.$crypto = crypto
Vue.prototype.$publickey =
	'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAo+WUqGOtzASqkMz4hzlDwC3eA2RBsgD23YTYytGx/2wwxFPVBP614M1EOVukZOtbl67eTTRJydUQz/i1ja/z/ftss5GfVeys/4jzvwWJfBHafwRVH2si9SitWOg16Wo/9uoTcuO3hXaFx4902G1LmOX06Z1ZUjaphWp5eRfEVQVQl9FzK6q4nwQZBA9MzA7syQijV2scQw1z+5tAGYarC0P0N17m99Zju2KGZ8GZF7rWkLpBR4gAGOJXZ6ZJcGypbHlAEFEKSQBZ9DRmInOUXrhRW3wUugiQGEHCBNDkCtG+UQb65/W37WaUVq9IKCPJJnmJZrty3oKdQ7cQRlNUdQIDAQAB'
Vue.prototype.$wd_hosturl = process.env.VUE_APP_BASE_HOST
Vue.prototype.$wd_title = process.env.VUE_APP_BASE_TITLE
Vue.prototype.$wd_limit = 10
Vue.prototype.$wdpicurl = function(url, ishead = false) {
	if (url === undefined || url === null || url === '') {
		if (ishead) {
			return '/img/user_no.jpg'
		} else {
			return ''
		}
	}
	if (url === '/img/lazyload.png') {
		return url
	}
	if (url.indexOf('static') > -1) {
		return url
	}
	var picurl = this.$wd_hosturl; //sessionStorage.getItem('picurl') || ''
	return url.startsWith('http') ? url : url.startsWith('/') ? picurl + url : picurl + '/' + url
}
Vue.prototype.$wd_getsign = function(funname) {
	var timestamp = this.$weidajs.getDateTime();
	// if (!this.$store.state.logininfo.islogin){
	// 	let ldata=uni.getStorageSync("wdmem");
	// 	if (ldata!=""){
	// 		var min=0;
	// 		if (ldata.tokentime===undefined){
	// 			min=14401;
	// 		}else{
	// 			min=this.$weidajs.datediffmi(ldata.tokentime,this.$weidajs.getDateTime());
	// 		}
	// 		if (min<14400){
	// 			ldata.tokentime = timestamp;
	// 			uni.setStorageSync("wdmem",ldata)
	// 			this.$store.commit("login",ldata);
	// 		}else{
	// 			uni.removeStorageSync("wdmem");
	// 		}
	// 	}
	// }
	checklogin();
	// var a = getToken("wdtoken");
	
	let indata = {};
	indata.fun = funname;
	if (funname!=="loginin"){
		var memguid=this.$store.state.logininfo.myinfo.memguid||"";
		if (memguid!==""){
			indata.memguid=memguid;
		}
	}
	indata.nonestr = this.$weidajs.wdnonestr();
	indata.netcode = process.env.VUE_APP_NETCODE;
	indata.netpass = process.env.VUE_APP_NETPASS;
	indata.timestamp = timestamp;

	// console.log(indata);
	var token = this.$store.state.logininfo.token;
	if (token === undefined || token == "") {
		token = this.$weidajs.wdnonestr();
	}
	indata.token = token;
	indata.version = '1.2.5';
	var json = JSON.stringify(indata);
	var sign = crypto.MD5(json).toString();
	indata.sign = sign;
	return indata;
}
Vue.prototype.$wd_request= function(funname, data={}, loading = false, target = '#app') {
	let indata ={};
	
	if (funname !== 'upimg') {
		indata=this.$wd_getsign(funname);
		indata.apptype = "web";
		Object.assign(indata, data);
	}else{
		indata=data;
	}
	
	
	// console.log('----',process.env.NODE_ENV);
	// console.log('---',process.env.VUE_APP_BASE_API);
	// console.log('--', process.env);
	if (process.env.NODE_ENV === 'development') {
		indata.fun = funname
		console.log(indata);
	}
	// bindata.netcode = 'wdtest'
	// bindata.netpass = 'wdtest888'
	// if (funname !== 'upimg') {
	// 	bindata.sign = this.$wd_getsign(funname)
	// }
	var wdloading = ''
	if (loading) {
		wdloading = this.$loading({
			lock: true,
			// text: '请稍候...',
			// spinner: 'el-icon-loading',
			// fullscreen: false,
			target: target,
			body:true
			// background: 'rgba(240, 240, 240, 0.7)'
		})
	}
	return new Promise(function(resolve, reject) {
		request({
			url: 'weidaopt',
			method: 'post',
			data: indata
		}).then(data => {
			if (funname === "loginin") {
				setToken(data.token)
			}
			resolve(data)
			if (loading) {
				wdloading.close()
			}
		}).catch(data => {
			if (data.rs==-2){
				console.log("login");
			}
			reject(data)
			if (loading) {
				wdloading.close()
			}
		})
	})
}
Vue.prototype.$wdupimg = function(file) {
  var formdata = new FormData()
  
  var signdata=this.$wd_getsign('upimg');
  formdata.append('memguid', signdata.memguid);
  formdata.append('fun', signdata.fun);
  formdata.append('nonestr', signdata.nonestr);
  formdata.append('netcode', signdata.netcode);
  formdata.append('netpass', signdata.netpass);
  formdata.append('timestamp', signdata.timestamp);
  formdata.append('token', signdata.token);
  formdata.append('version', signdata.version);
  formdata.append('upfile', file);
  return new Promise((resolve, reject) => {
    this.$wd_request('upimg', formdata)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        console.log('error')
        reject(error)
      })
  })
}
Vue.prototype.$wd_toast = function(msg, type = 'success') {
	// type:success/warning/info/error
	this.$message({
		message: msg,
		type: type
	})
}
Vue.prototype.$wd_msg = function(msg, title = '温馨提示') {
	// type:success/warning/info/error
	this.$alert(msg, title);
}
function checklogin(){
	var tmp=localStorage.getItem("wdmem");
	var ldata;
	try{
		ldata=JSON.parse(tmp);	
	}catch(e){
		ldata=null;
	}
	if (ldata!==null){
		var timestamp=weidajs.getDateTime();
		var tokentime=ldata.tokentime;
		var min=0;
		if (tokentime===undefined){
			min=130;
		}else{
			min=weidajs.datediffmi(tokentime,timestamp);
		}
		if (min<120){
			if (min<10){
				ldata.tokentime = timestamp;
				localStorage.setItem("wdmem",JSON.stringify(ldata));
			}
			store.commit("login",ldata);
			setToken("wdtoken",ldata.token);
		}else{
			localStorage.removeItem("wdmem");
		}
	}
	return store.state.logininfo.islogin;
}
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title
	}
	if (to.matched.some(wd => wd.meta.needlogin)) {
		var islogin=store.state.logininfo.islogin;
		
		if (!islogin) {
			if (!checklogin()){
				next({
					path: '/login',
					query: {
						redirect: to.fullPath
					}
				})
			}else{
				next();
			}
		} else {
			next()
		}
	} else {
		next()
	}
})
router.afterEach(()=>{
	window.scrollTo(0,0);
})
const originalPush = router.push
router.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
